import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <a 
            href="/info.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('privacyPolicy')}
          </a>
        </div>
        <div className="footer-copyright">
          © {currentYear} HanseFood. {t('allRightsReserved')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;

